import React from "react";

import FormattedAmount from "pages/_components/FormattedAmount";
import { bool, number, shape } from "prop-types";

import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";

const TotalInvestedCapital = ({ totalInvestedCapital, isDesktop }) => (
    <GridTable className="total-invested-capital account-totals box box-primary">
        <GridTable.Container>
            <GridTable.Data columnStart={1} columnWidth={isDesktop ? 1 : 3} alignX="flex-start">
                <CustomText text="deposits.totalInvested.Capital" textType="I18N" />
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 2 : 1}
                rowStart={isDesktop ? 1 : 2}
                columnWidth={isDesktop ? 2 : 1}
                alignX="flex-start">
                <FormattedAmount className="data-amount" currency="ARS" quantity={totalInvestedCapital.mainCurrency} />
            </GridTable.Data>
            {!isDesktop && 
                <GridTable.Data columnStart={2} rowStart={2} columnWidth={1} alignX="flex-start">
                    <span className="pipe-separator data-amount">|</span>
                </GridTable.Data>
            }
            <GridTable.Data
                columnStart={isDesktop ? 4 : 3}
                rowStart={isDesktop ? 1 : 2}
                columnWidth={isDesktop ? 2 : 1}
                alignX="flex-start">
                <FormattedAmount className="data-amount" currency="USD" quantity={totalInvestedCapital.USD} />
            </GridTable.Data>
        </GridTable.Container>
    </GridTable>
);

TotalInvestedCapital.propTypes = {
    totalInvestedCapital: shape({ mainCurrency: number, USD: number }),
    isDesktop: bool.isRequired,
};
TotalInvestedCapital.defaultProps = {
    totalInvestedCapital: { mainCurrency: 0, USD: 0 },
};

export default TotalInvestedCapital;
